import React, {FC, useEffect, useRef, useState} from 'react'
import { StepperComponent } from '../../../../../_metronic/assets/ts/components'
import { createAccountSchemas } from '../../../../modules/wizards/components/CreateAccountWizardHelper'
import { ScreenDetailsProposals } from '../ScreenDetailsProposal'
import { ScreenAddEditProposal } from '../ScreenAddEditProposal'
import { ModalAddUpdateClient } from '../../../clients/components/ModalAddEditClient'

type Props = {
    closed: any,
    proposal: any,
    data: any,
    setProposal: any,
    refresh?: () => void,
}

const MenuAddEditProposal = ({
    closed, data, proposal, setProposal, refresh
} : Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])
  const [isSubmitButton, setSubmitButton] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber)
  }

  const submitStep = () => {
    if (!stepper.current) {
      return
    }

    if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
    } else {
      stepper.current.goto(1)
      //actions.resetForm()
    }
    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totatStepsNumber)
    //setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }
    loadStepper()
  }, [stepperRef])

  const [showCreateAppModal, setShowCreateAppModal] = useState(false)
  const [clientsReloadToken, setClientsReloadToken] = useState(0)
  const [newClientIdToSelect, setNewClientIdToSelect] = useState<string | undefined>(undefined)

  const handleClientModalSuccess = (result?: unknown) => {
    let id: string | undefined
    if (result && typeof result === 'object' && result !== null && 'id' in result) {
      const raw = (result as { id: unknown }).id
      if (typeof raw === 'string') {
        id = raw
      } else if (typeof raw === 'number') {
        id = String(raw)
      }
    }
    if (id) {
      setNewClientIdToSelect(id)
    }
    setClientsReloadToken((t) => t + 1)
    refresh?.()
  }

  return (
    <div
        ref={stepperRef}
        className='stepper stepper-links d-flex flex-column'
        id='kt_create_account_stepper'
    >
        <div className='mb-5 px-lg-10' style={{ marginLeft: '5%', marginRight: '5%' }}>
          <div
            className='px-lg-2 d-flex justify-content-center align-items-center'
          >
            <div className='stepper-nav mb-0'>
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                <h3 className='stepper-title'>Prenchimento dos Dados</h3>
              </div>

              <div className={`stepper-item`} data-kt-stepper-element='nav'>
                <h3 className={`stepper-title ${!data ? 'text-muted' : ''}`}>Adição dos Itens</h3>
              </div>
            </div>
          </div>
        </div>

        <div className='' id='kt_create_account_form'>
            <div className='current' data-kt-stepper-element='content'>
                <ScreenAddEditProposal
                  handleClose={closed}
                  id={data ? data.id : null}
                  data={data ? data : null}
                  setData={setProposal}
                  isSubmitButton={isSubmitButton}
                  prevStep={prevStep}
                  submitStep={submitStep}
                  clientsReloadToken={clientsReloadToken}
                  newClientIdToSelect={newClientIdToSelect}
                  onAppliedNewClientSelection={() => setNewClientIdToSelect(undefined)}
                  onOpenNewClientModal={() => setShowCreateAppModal(true)}
                />
            </div>

            <div data-kt-stepper-element='content'>
                <ScreenDetailsProposals 
                  handleClose={closed}
                  id={data ? data.id : null}
                  data={data ? data : null}
                  isSubmitButton={isSubmitButton}
                  prevStep={prevStep}
                  submitStep={submitStep}
                />
            </div>

            {/* <div className='d-flex flex-stack pt-15'>
                <div className='mr-2'>
                <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                >
                    <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-4 me-1'
                    />
                    Back
                </button>
                </div>

                <div>
                <button onClick={submitStep} className='btn btn-lg btn-primary me-3'>
                    <span className='indicator-label'>
                    {!isSubmitButton && 'Continue'}
                    {isSubmitButton && 'Submit'}
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                    </span>
                </button>
                </div>
            </div> */}
        </div>

        <ModalAddUpdateClient
          show={showCreateAppModal}
          id={undefined}
          data={undefined}
          handleClose={() => setShowCreateAppModal(false)}
          onSuccess={handleClientModalSuccess}
        />

    </div>
  )
}

export {MenuAddEditProposal}